import { Inject, Injectable } from '@angular/core';

import { RaceEntity, RacingProviders } from '@cds/betting-offer/domain-specific/horse-racing';
import { DetailedCreateFactory, DetailedGroupingFactory } from '@frontend/sports/betting-offer/feature/fixture-factories';
import { OfferGroupingService } from '@frontend/sports/betting-offer/feature/offer-grouping';
import { RacingConfig } from '@frontend/sports/common/client-config-data-access';
import { BaseCdsApiFactory, CDS_API_FACTORY } from '@frontend/sports/content-distribution/feature';
import { WinGameFixture, toRacingPostFixture } from '@frontend/sports/racing/feature/models';

import { AbstractRacingService } from './racing-api.service';

@Injectable({
    providedIn: 'root',
})
export class GreyhoundRacingApiService extends AbstractRacingService {
    ToFixture(raceEntity: RaceEntity): WinGameFixture {
        return toRacingPostFixture(raceEntity);
    }

    provider(): RacingProviders {
        return RacingProviders.RacingPost;
    }

    constructor(
        @Inject(CDS_API_FACTORY) cdsApiServiceFactory: BaseCdsApiFactory,
        protected override racingConfig: RacingConfig,
        protected override offerGroupingService: OfferGroupingService,
        protected override createFactory: DetailedCreateFactory,
        protected override groupingFactory: DetailedGroupingFactory,
    ) {
        super(cdsApiServiceFactory, racingConfig, '/greyhounds-racing', offerGroupingService, createFactory, groupingFactory);
    }
}
